/* styles/widgets/sliders */ function _(require, module, exports) {
    require(311) /* ../root */;
    require(473) /* ./nouislider */;
    var _a = require(5) /* ../../core/dom */;
    _a.styles.append(".bk-root .bk-slider-title {\n  white-space: nowrap;\n}\n.bk-root .bk-slider-value {\n  font-weight: 600;\n}\n");
    exports.bk_slider_value = "bk-slider-value";
    exports.bk_slider_title = "bk-slider-title";
    exports.bk_input_group = "bk-input-group";
}
